export default __webpack_public_path__ + "static/media/users-on.46b9ad96.svg";